const isMenuItemVisible = (item) =>
  typeof item.visible === 'function' ? item.visible() : item.visible !== false

export { isMenuItemVisible }
